module.exports = __webpack_public_path__ + "static/media/CommanderShepard.599a9e6c.jpg";